import React, { useCallback } from "react";
import cx from "classnames";
import { FormApi } from "final-form";
import { Field, Form } from "react-final-form";
import { StaticImage } from "gatsby-plugin-image";
// @ts-ignore
import addToMailchimp from "gatsby-plugin-mailchimp";

import {
  composeValidators,
  focusOnErrors,
  required,
  validateEmail,
} from "utils/validators";
import { useSuccess } from "hooks/useSuccess";
import { Input } from "components/ui/Input";
import { Button } from "components/ui/Button";
import { Container } from "components/common/Container";
import GlassIllustration from "svg/glass-subscribe.inline.svg";

import * as s from "./SubscriptionForm.module.sass";

type FormValues = {
  email: string;
};

export const SubscriptionForm: FC = ({ className }) => {
  const { toggleSuccess } = useSuccess();

  const handleSubscribe = useCallback(
    async (values: FormValues, form: FormApi<FormValues>) => {
      try {
        const result = await addToMailchimp(values.email);
        if (result.result === "error") {
          return { email: result.msg };
        }

        setTimeout(form.restart);
        toggleSuccess(true);
      } catch (err: any) {
        return { email: err?.message };
      }
      return;
    },
    [toggleSuccess]
  );

  return (
    <div className={cx(s.root, className)}>
      <Container className={s.container}>
        <Form<FormValues>
          onSubmit={handleSubscribe}
          decorators={[focusOnErrors]}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit} className={s.form}>
              <GlassIllustration className={s.illustration} />
              <div className={s.wavesLeft}>
                <StaticImage
                  src="../../../../images/subscribe-waves-left.png"
                  // objectFit="contain"
                  placeholder="none"
                  quality={80}
                  alt="Stay up to date with our newsletter"
                />
              </div>
              <div className={s.wavesRight}>
                <StaticImage
                  src="../../../../images/subscribe-waves-right.png"
                  // objectFit="contain"
                  placeholder="none"
                  quality={80}
                  alt="Stay up to date with our newsletter"
                />
              </div>
              <h2 className={s.header}>Stay up to date with our newsletter</h2>
              <Field
                name="email"
                validate={composeValidators(required, validateEmail)}
              >
                {({ input, meta }) => (
                  <div className={s.inputWrapper}>
                    <Input
                      placeholder="Enter your e-mail"
                      error={meta.touched && meta.error}
                      inputClassName={s.input}
                      {...input}
                    />
                  </div>
                )}
              </Field>
              <Button type="submit" disabled={submitting} className={s.button}>
                {submitting ? "Loading..." : "Subscribe"}
              </Button>
            </form>
          )}
        />
      </Container>
    </div>
  );
};
